var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumeric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#d5ffe6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.308 28.869H8.198v-1.684h24.11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.775 22.923v-8.265H10.87l-2.673 1.789v1.836l2.55-1.692h.123v6.332H8.204v1.624h7.1v-1.624zM16.592 17.64v.04H18.4v-.048c0-.945.658-1.59 1.638-1.59.959 0 1.583.563 1.583 1.42 0 .664-.35 1.185-1.7 2.534l-3.22 3.187v1.364h6.968v-1.638h-4.324v-.124l1.933-1.843c1.672-1.603 2.24-2.528 2.24-3.611 0-1.713-1.377-2.871-3.419-2.871-2.076 0-3.508 1.288-3.508 3.18zM27.61 20.209h1.18c1.137 0 1.87.569 1.87 1.453 0 .87-.72 1.425-1.85 1.425-1.062 0-1.775-.534-1.843-1.377h-1.803c.09 1.85 1.542 3.035 3.7 3.035 2.214 0 3.728-1.199 3.728-2.953 0-1.309-.794-2.186-2.13-2.344v-.123c1.082-.22 1.747-1.076 1.747-2.24 0-1.563-1.364-2.625-3.372-2.625-2.09 0-3.412 1.137-3.48 2.994h1.733c.061-.87.713-1.425 1.686-1.425.993 0 1.624.52 1.624 1.343 0 .83-.644 1.37-1.631 1.37H27.61z"
  })));
}

export default SvgNumeric;